import React, {useEffect} from 'react';
import {useAsync} from "react-async";
import {httpClient} from "../../service/ApiService";
import LoadingHtml from "../../shared/Loading";
import ErrorPage from "../../shared/ErrorPage";
import IntroductionHtml from "./html/IntroductionHtml";
import {ActionResult,  HttpMethod} from "../../model";

const Introduction = () => { // 추가
    const url = 'infos/combos';
    const options = {promiseFn: httpClient, method: HttpMethod.GET, url};
    const {data: act, error, isLoading} = useAsync<ActionResult>(options);

    if (isLoading) return <LoadingHtml/>;
    if (error) return <ErrorPage/>;
    if (!act) return null;
    if (!act.result) return <ErrorPage/>;
    return <IntroductionHtml cities={act.data.cities} categories={act.data.categories} />
};

export default Introduction;
